import { ChakraComponent, Spinner, Stack } from '@chakra-ui/react';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useFetchSomeUsersQuery } from '../../api';
import { ClipText } from './ClipText';

export interface UserLabelProps {
  value: string | undefined;
}

const Internal = (props: UserLabelProps) => {
  const { value, ...other } = props;
  const { data: users } = useFetchSomeUsersQuery(
    { ids: [value ?? "0"] },
    {
      skip: !value,
    }
  );

  const user = useMemo(() => (users ? users[0] : undefined), [users]);

  if (!value) {
    return <ClipText text="N/A" />;
  } else if (!user) {
    return <Spinner size="xs" />;
  } else {
    return (
      <Link to={`/app/users/${value}/detail`} {...other}>
        <Stack>
          <ClipText
            text={`${user?.preferredName || user?.firstName} ${user?.lastName}`}
          />
        </Stack>
      </Link>
    );
  }
};

export const UserLabel = Internal as ChakraComponent<'label', UserLabelProps>;
